import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import ShowMore from '../../../../../../components/ShowMore';
import REVIEW_TYPES from '../../../../../../constants/review-types';
import LinkBuilder from '../../../../../../helpers/link-builder';
import {Role} from '../../../../../../helpers/user';
import UpgradeRecruiterAccount from '../../../../../Dialog/components/UpgradeRecruiterAccount';

const InboxItemTo = props => {
  const { user, message } = props;

  const {
    To,
    ToID,
    ToType,
    ToName,
    FirmName,
    FirmUrlAlias,
    ReviewType,
    OverviewID,
    InterviewID,
    ReviewID,
    ReviewPublicName,
    ToCandidateID,
  } = message;

  const links = useMemo(() => {
    if (ReviewType) {
      const obj = {
        name: `Author of ${FirmName} ${
          ReviewType === REVIEW_TYPES.OVERVIEW ? 'Company' : ReviewType
        } Review`,
        link: null,
        key: ToCandidateID || uniqueId(),
      };

      if (OverviewID) {
        obj.link = LinkBuilder.getOverviewLink(FirmUrlAlias, ReviewPublicName);
        obj.isLink = true;
      }
      if (InterviewID) {
        obj.link = LinkBuilder.getInterviewLink(FirmUrlAlias, ReviewPublicName);
        obj.isLink = true;
      }
      if (ReviewID) {
        obj.link = LinkBuilder.getEmployeeLink(FirmUrlAlias, ReviewPublicName);
        obj.isLink = true;
      }

      return [obj];
    }

    if (To && !!To.length) {
      return To.map(
        ({
          ToViewAsRecruiter,
          ToCandidateID,
          ToName,
          ToViewProfile,
          ToIsActiveCandidate,
        }) => {
          const viewProfile = ToViewProfile === 'Yes';
          const viewAsRecruiter = ToViewAsRecruiter === 'Yes';

          let profileLink =
            (!Role.isCandidate(user) && Role.isRecruiterDefault(user)) ||
            (!Role.isRecruiter(user) && !Role.isCandidate(user))
              ? '#'
              : LinkBuilder.getProfileLink(ToCandidateID);

          const isLink =
            ToIsActiveCandidate === 'Yes' &&
            ((Role.isCandidate(user) && viewProfile) ||
              (Role.isRecruiter(user) &&
                !Role.isRecruiterDefault(user) &&
                viewAsRecruiter));

          return {
            isLink,
            name: ToName,
            link: profileLink,
            key: ToCandidateID || uniqueId(),
          };
        }
      );
    }

    return [
      {
        name: ToType === 'admin' ? 'System Administrator' : ToName,
        link: null,
        key: ToID || uniqueId(),
      },
    ];
  }, []);

  const onClickProfileLink = (e, user) => {
    if (!Role.isCandidate(user) && Role.isRecruiterDefault(user)) {
      UpgradeRecruiterAccount();
      e.preventDefault();
    } else if (!Role.isRecruiter(user) && !Role.isCandidate(user, true)) {
      e.preventDefault();
    }
  };

  const renderExcerpt = links
    .slice(0, 3)
    .map(({ name, link, key, isLink }, index) => (
      <span key={key} className="inbox-item__link">
        {isLink ? (
          <NavLink
            className="inbox-item__title"
            to={link}
            onClick={e => onClickProfileLink(e, user)}
          >
            {name}
          </NavLink>
        ) : (
          <span className="inbox-item__title inbox-item__title--linkless">
            {name}
          </span>
        )}
        {index === links.slice(0, 3).length - 1 ? '...' : ','}
      </span>
    ));

  const renderAll = links.map(({ name, link, key, isLink }, index) => (
    <span key={key} className="inbox-item__link">
      {isLink ? (
        <NavLink
          className="inbox-item__title"
          to={link}
          onClick={e => onClickProfileLink(e, user)}
        >
          {name}
        </NavLink>
      ) : (
        <span className="inbox-item__title inbox-item__title--linkless">
          {name}
        </span>
      )}
      {index === links.length - 1 ? '' : ','}
    </span>
  ));

  return (
    <div className="inbox-item__person">
      {links.length > 3 ? (
        <>
          <ShowMore renderExcerpt={renderExcerpt} renderAll={renderAll} />
        </>
      ) : (
        renderAll
      )}
    </div>
  );
};

InboxItemTo.propTypes = {
  user: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
};

export default InboxItemTo;
